import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaUser,
  FaClipboardList,
  FaUsers,
  FaSignOutAlt,
  FaUserTag,
} from "react-icons/fa";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../redux/user/userSlice";

export default function DashSidebar() {
  const dispatch = useDispatch();
  const location = useLocation();
  const [tab, setTab] = useState("");

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabFromUrl = urlParams.get("tab");
    if (tabFromUrl) {
      setTab(tabFromUrl);
    }
  }, [location.search]);

  const handleLogout = () => {
    dispatch(logoutUser());
    window.location.href = "/signin";
  };

  return (
    <div className="bg-gradient-to-b from-gray-800 to-slate-500 text-white h-full p-4">
      <ul>
        <li className="mb-2">
          <Link
            to="/dashboard?tab=profile"
            className={`flex items-center hover:bg-gray-700 rounded-lg p-2 ${
              tab === "profile" && "bg-gray-700"
            }`}
          >
            <FaUser className="mr-2" /> Profile
          </Link>
        </li>
        <li className="mb-2">
          <Link
            to="/dashboard?tab=tournaments"
            className={`flex items-center hover:bg-gray-700 rounded-lg p-2 ${
              tab === "tournaments" && "bg-gray-700"
            }`}
          >
            <FaClipboardList className="mr-2" /> Tournaments
          </Link>
        </li>
        <li className="mb-2">
          <Link
            to="/dashboard?tab=teams"
            className={`flex items-center hover:bg-gray-700 rounded-lg p-2 ${
              tab === "teams" && "bg-gray-700"
            }`}
          >
            <FaUsers className="mr-2" /> Teams
          </Link>
        </li>
        <li className="mb-2">
          <Link
            to="/dashboard?tab=rosters"
            className={`flex items-center hover:bg-gray-700 rounded-lg p-2 ${
              tab === "rosters" && "bg-gray-700"
            }`}
          >
            <FaUserTag className="mr-2" /> Rosters
          </Link>
        </li>
        <li className="mb-2">
          <button
            onClick={handleLogout}
            className="flex items-center hover:bg-gray-700 rounded-lg p-2"
          >
            <FaSignOutAlt className="mr-2" /> Logout
          </button>
        </li>
      </ul>
    </div>
  );
}
